import React, { useState, useEffect, useContext } from 'react';
import {Button, Form, Input, InputGroup} from 'reactstrap';
import {signUp} from 'utils/api/authApi';
import {Link, useHistory} from 'react-router-dom';
import { toast } from 'react-toastify';
import './style.scss';
import {connect} from 'react-redux';
import {logout} from 'redux/modules/auth/action';
import SpinnerButton from 'components/SpinnerButton/SpinnerSubmitButton';
import InputWithError from 'components/InputWithError';
import {ErrorContext} from 'contexts/ErrorContext';

const SignUpPage = ({auth, logout}) => {
    let history = useHistory();
    let {handleErrors} = useContext(ErrorContext);

    const [login, setLogin] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [mailSend, checkMailSend] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if(auth && auth.isAuthenticated) {
            logout();
            history.push('/signin')
        }
    }, [])


    const handleChange = (value) => {
        if (value.split('')[0] === ' ' || value.split('')[value.length - 1] === ' ') {
            return;
        }

        setLogin(value);

        const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        setIsEmailValid(emailRegExp.test(value));
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        setError(null);
        const href = window.location.href;
        const count = href.indexOf('signup');
        const route = href.slice(0, count);
        const params = {
            email: login,
            // targetUrl: process.env.production ? 'https://app.newsfetch.io/finish' : `${route}finish`,
            targetUrl: `${route}finish`,
        };

        try {
            setSubmitting(true);
            await signUp(params);
            checkMailSend(true);
            setSubmitting(false);
        } catch(err) {
            setSubmitting(false);
            console.log(err)
            handleErrors(err, setError);
            // e.errors.email && toast.error(e.errors.email[0].message);
            // throw e.message;
        }
    };

    if(auth && auth.isAuthenticated) return null;
    return (
        <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: 'calc(100vh - 100px)', width: '100%' }}>
            {mailSend ? (
                <div className="d-flex flex-column authorization-container">
                    <h3 className="align-self-center mb-5" style={{ fontWeight: '700', fontFamily: 'Sans-serif' }}>
                        Check your inbox
                    </h3>
                    <p className="align-self-center mb-2 font-weight-bold text-center">
                        We just emailed a confirmation link to <br />
                        {`${login}`}
                    </p>
                    <p className="align-self-center mb-2 font-weight-bold text-center">
                        Follow the link to finish setting up your account.
                    </p>
                </div>
            ) : (
                <div className="d-flex flex-column authorization-container">
                    <h3 className="align-self-center mb-3" style={{ fontWeight: '700', fontFamily: 'Sans-serif' }}>
                        Sign Up
                    </h3>
                    <p className="align-self-center mb-3">Create an account</p>
                    <form onSubmit={handleSubmit}>
                        {/*<InputGroup className="mb-3">*/}
                        {/*    <div className="input-group-prepend">*/}
                        {/*        <span style={{ width: '40px' }} className="input-group-text" id="basic-addon1">*/}
                        {/*            <i className="fas fa-at" />*/}
                        {/*        </span>*/}
                        {/*    </div>*/}
                        {/*    <Input value={login} onChange={(e) => handleChange(e.target.value)} placeholder="Enter your email" />*/}
                        {/*</InputGroup>*/}
                        <InputWithError
                            value={login}
                            placeholder="Enter your email"
                            onChange={handleChange}
                            prependIcon={<i className="fas fa-at"/>}
                            errorObj={error}
                            name="email"
                            marginBottomClass="mb-3"
                        />
                        <div className="d-flex flex-column justify-content-between align-self-start">
                            {/*{loading ? (*/}
                            {/*    <Button*/}
                            {/*        style={{ color: 'white', fontWeight: '700' }}*/}
                            {/*        value="Login"*/}
                            {/*        onClick={() => {}}*/}
                            {/*        className="btn calltoaction-button d-flex justify-content-center"*/}
                            {/*    >*/}
                            {/*        <i className="fa fa-spinner fa-spin" />*/}
                            {/*    </Button>*/}
                            {/*) : (*/}
                            {/*    <Input*/}
                            {/*        disabled={!isEmailValid}*/}
                            {/*        type="Submit"*/}
                            {/*        value="Create Account"*/}
                            {/*        className="btn calltoaction-button"*/}
                            {/*    />*/}
                            {/*)}*/}
                            <SpinnerButton
                                // onClick={handleSubmit}
                                title="Create Account"
                                submitting={submitting}
                                block
                            />
                        </div>
                    </form>
                    <div className="mt-2 d-flex justify-content-center">
                        Already have an account?
                        <Link
                            to="/signin"
                            style={{
                                marginLeft: 5,
                                textDecoration: 'underline',
                            }}
                        >
                            Sign in
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateFromProps,
    { logout }
)(SignUpPage);
